import {
  OrderPriceTaxBreakdown,
  PricingBreakDown,
  PricingList,
} from "@api/graphql/generated/generated-types";
import {
  BaseModal,
  BaseModalBody,
  BaseModalHeader,
  PricingBreakdownContent,
} from "@src/common/components";
import { useEiaFuelRateByRuleId } from "@src/common/components/EiaFuelRateNote";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  /** Enables the EIA fuel rate note on dynamic fuel lines when provided. */
  orderId?: string;
  breakdown: PricingBreakDown;
  total: string;
  pricingList: PricingList | undefined | null;
  taxBreakDown?: OrderPriceTaxBreakdown | null;
  totalAfterTax?: string;
};

export function PricingBreakDownModal({
  isOpen,
  onClose,
  orderId,
  breakdown,
  total,
  pricingList,
  taxBreakDown,
  totalAfterTax,
}: Props) {
  // Fetched only while the modal is mounted with an order; quote previews pass no orderId.
  const eiaFuelRateByRuleId = useEiaFuelRateByRuleId(isOpen ? orderId : undefined);
  return (
    <BaseModal isOpen={isOpen} onClose={onClose}>
      <BaseModalHeader>Price Breakdown</BaseModalHeader>
      <BaseModalBody>
        <PricingBreakdownContent
          pricingBreakDown={breakdown}
          total={total}
          pricingListName={pricingList?.name}
          taxBreakDown={taxBreakDown}
          totalAfterTax={totalAfterTax}
          eiaFuelRateByRuleId={eiaFuelRateByRuleId}
        />
      </BaseModalBody>
    </BaseModal>
  );
}
